// Shared label logic for the booking / reschedule / cancellation cards.
// Contract: vendor_info.booking_noun null/missing/empty = legacy -> "Tour".
// The "Where" row names the virtual provider for google_meet / teams; the
// anchor is rendered ONLY for https:// links (never javascript:, http:, etc).

import type { ReactNode } from 'react'

export function bookingNoun(noun: string | null | undefined): string {
  const n = typeof noun === 'string' ? noun.trim() : ''
  return n || 'Tour'
}

export function bookingStatusLabel(
  noun: string | null | undefined,
  status: 'confirmed' | 'rescheduled' | 'cancelled'
): string {
  const n = bookingNoun(noun)
  return n.charAt(0).toUpperCase() + n.slice(1) + ' ' + status
}

const PROVIDERS: Record<string, string> = {
  google_meet: 'Google Meet',
  teams: 'Microsoft Teams',
}

export function whereValue(
  parsed: Record<string, unknown>,
  businessName: string
): ReactNode {
  const type = parsed.meeting_type
  // Own keys only: 'constructor' / 'toString' must not resolve via the prototype.
  const provider =
    typeof type === 'string' && Object.prototype.hasOwnProperty.call(PROVIDERS, type)
      ? PROVIDERS[type]
      : undefined
  if (!provider) return businessName
  const link = parsed.meet_link
  if (typeof link === 'string' && link.startsWith('https://')) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer" className="underline">
        {provider}
      </a>
    )
  }
  return provider + ' (link in your calendar invite)'
}
